import { useEffect, useId, useRef } from 'react'
import { useI18n } from '../lib/i18n'
import './route-error-recovery.css'

export function RouteErrorRecovery() {
  const { l, locale, isRtl } = useI18n()
  const titleId = useId()
  const title = useRef<HTMLHeadingElement>(null)
  useEffect(() => { title.current?.focus() }, [])
  return <main className="route-error-recovery" dir={isRtl ? 'rtl' : 'ltr'} lang={locale}>
    <section role="alert" aria-labelledby={titleId}>
      <p className="route-error-recovery__brand">{locale === 'ar' ? 'سِعَة' : 'Seaa'}</p>
      <h1 ref={title} id={titleId} tabIndex={-1}>{l('Diese Seite konnte nicht geladen werden.', 'We could not load this page.', 'تعذّر تحميل هذه الصفحة.', 'Deze pagina kon niet worden geladen.')}</h1>
      <p>{l('Lade die Seite erneut. Wenn das Problem bleibt, kehre zur Startseite zurück.', 'Reload the page to try again. If the problem continues, you can return to the home page.', 'أعد تحميل الصفحة للمحاولة مجددًا. إذا استمرت المشكلة، يمكنك العودة إلى الصفحة الرئيسية.', 'Laad de pagina opnieuw. Als het probleem blijft, kun je terug naar de startpagina.')}</p>
      <div className="route-error-recovery__actions">
        <button type="button" onClick={() => { if (typeof window !== 'undefined') window.location.reload() }}>{l('Seite neu laden', 'Reload page', 'إعادة تحميل الصفحة', 'Pagina opnieuw laden')}</button>
        <a href={`/?lang=${locale}`}>{l('Zur Startseite', 'Go to home page', 'العودة إلى الرئيسية', 'Naar de startpagina')}</a>
      </div>
    </section>
  </main>
}
